import React from 'react';
import { OveitIcon } from '../OveitIcon';

interface CircularProgressBarProps {
  percent: number;
}

const CircularProgressBar: React.FC<CircularProgressBarProps> = ({
  percent,
}) => {
  return percent === 100 ? (
    <div className="w-4">
      <OveitIcon name="solidGreenCheck" />
    </div>
  ) : (
    <div className="card">
      <svg>
        <circle cx="10" cy="10" r="8"></circle>
        <circle
          cx="10"
          cy="10"
          r="8"
          style={{ '--percent': percent } as any}
        ></circle>
      </svg>
    </div>
  );
};

export default CircularProgressBar;
